import { CommonRequestService } from './common-request.service';
import { AppSettings } from 'app/app.settings';
import { UserService } from './user.service';
import * as i0 from "@angular/core";
import * as i1 from "./common-request.service";
import * as i2 from "./user.service";
var NagService = /** @class */ (function () {
    function NagService(requestService, userService) {
        this.requestService = requestService;
        this.userService = userService;
        this.changedNctNames = [];
    }
    NagService.prototype.getNagCategories = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagCategory';
            _this.requestService.requestGet(url, null, function (rsp) {
                var nagCates = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        nagCates.push({
                            id: d.nct_id,
                            name: d.nct_name,
                            desc: d.nct_desc,
                            parentId: d.nct_parent_id,
                            parentCate: d.parent_category,
                            isSpatial: d.nct_is_spatial
                        });
                    });
                }
                resolve(nagCates);
            }, function (err) {
                reject(err);
            });
        });
    };
    NagService.prototype.getNagSubCategory = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagSubCategory';
            _this.requestService.requestGet(url, null, function (rsp) {
                var subs = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        subs.push({
                            id: d.nsg_id,
                            name: d.nsg_name,
                            desc: d.nsg_desc
                        });
                    });
                }
                _this.placeTypes = subs;
                resolve(subs);
            }, function (err) { return reject(err); });
        });
    };
    NagService.prototype.getNagNamesStandard = function (cateId, stateCode, gfo, paging) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesStandard';
            var params = {
                nctId: cateId.toString(),
                customerId: _this.userService.getCustomerIdByType()
            };
            if (stateCode) {
                params.stateCode = stateCode;
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (paging) {
                _this.requestService.setParamsPaging(params, paging);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve({
                    data: rsp.data,
                    totalCount: rsp.totalCount,
                    misc: rsp.misc
                });
            }, function (err) {
                reject(err);
            });
        });
    };
    NagService.prototype.getNagNamesAlias = function (standardId, cateId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
            _this.requestService.requestGet(url, {
                params: {
                    stnId: standardId.toString(),
                    nctId: cateId.toString(),
                    customerId: _this.userService.getCustomerIdByType()
                }
            }, function (rsp) {
                var aliasList = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        aliasList.push(({
                            id: d.aln_id,
                            name: d.aln_name,
                            stnId: d.aln_stn_id,
                            cusId: d.aln_cus_id,
                            cusLevel: d.level,
                            cusNameShort: d.cus_name_short
                        }));
                    });
                }
                resolve(aliasList);
            }, function (err) {
                reject(err);
            });
        });
    };
    // Add a standard name
    NagService.prototype.addStandard_location = function (categoryId, standardName, subCates, parentId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesStandardLocation';
            var body = {
                nctId: categoryId,
                stnName: standardName.toUpperCase(),
                subcates: JSON.stringify(subCates),
                customerId: _this.userService.getCustomerIdByType()
            };
            if (parentId || parentId === 0) {
                body.stnParentId = parentId;
            }
            _this.requestService.requestPost(url, body, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    NagService.prototype.addStandard_street = function (categoryId, standardName, source) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesStandardStreet';
            var body = {
                nctId: categoryId,
                stnName: standardName.toUpperCase(),
                // source: source,
                customerId: _this.userService.getCustomerIdByType()
            };
            if (source) {
                body.source = source;
            }
            _this.requestService.requestPost(url, body, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    // Edit a standard name
    NagService.prototype.editStandard_location = function (cateId, standardId, standardName, subCates, parentId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesStandardLocation';
            var body = {
                nctId: cateId,
                stnId: standardId,
                stnName: standardName.toUpperCase(),
                subcates: JSON.stringify(subCates),
                customerId: _this.userService.getCustomerIdByType()
            };
            if (parentId || parentId === 0) {
                body.stnParentId = parentId;
            }
            _this.requestService.requestPut(url, body, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    // Edit a standard name
    NagService.prototype.editStandard_street = function (cateId, standardId, standardName, source) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesStandardStreet';
            var body = {
                nctId: cateId,
                stnId: standardId,
                stnName: standardName,
                source: source,
                customerId: _this.userService.getCustomerIdByType()
            };
            _this.requestService.requestPut(url, body, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    // Remove a standard name
    NagService.prototype.deleteStandard = function (cateId, standardId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesStandard';
            var body = {
                nctId: cateId,
                stnId: standardId,
                customerId: _this.userService.getCustomerIdByType()
            };
            _this.requestService.requestDelete(url, {
                body: body
            }, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    // Add an alias
    NagService.prototype.addAlias = function (cateId, standardId, aliasName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
            var body = {
                nctId: cateId,
                stnId: standardId,
                alnName: aliasName,
                customerId: _this.userService.getCustomerIdByType()
            };
            _this.requestService.requestPost(url, body, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    // Edit an alias
    NagService.prototype.editAlias = function (cateId, aliasId, aliasName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
            var body = {
                alnId: aliasId,
                alnName: aliasName,
                nctId: cateId,
                customerId: _this.userService.getCustomerIdByType()
            };
            _this.requestService.requestPut(url, body, function (rsp) { return resolve(); }, function (err) { return reject(err); });
        });
    };
    // Remove an alias
    NagService.prototype.deleteAlias = function (aliasId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
            var body = {
                alnId: aliasId,
                customerId: _this.userService.getCustomerIdByType()
            };
            _this.requestService.requestDelete(url, {
                body: body
            }, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    NagService.prototype.updateMvStComponents = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'a3i/mvStComponents';
            _this.requestService.requestPut(url, {}, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    NagService.prototype.getNagNamesStandardId = function (stnName, nctId, stateCode, countyName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagNamesStdId';
            var params = {
                stnName: stnName.toUpperCase(),
                nctId: nctId.toString(),
                stateCode: stateCode,
                customerId: _this.userService.getCustomerIdByType()
            };
            if (countyName) {
                params.countyName = countyName;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var list = [];
                if (rsp.data) {
                    rsp.data.forEach(function (i) { return list.push({
                        stnId: i.stn_id,
                        placeTypes: i.place_types
                    }); });
                }
                resolve(list);
            }, function (err) {
                reject(err);
            });
        });
    };
    NagService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NagService_Factory() { return new NagService(i0.ɵɵinject(i1.CommonRequestService), i0.ɵɵinject(i2.UserService)); }, token: NagService, providedIn: "root" });
    return NagService;
}());
export { NagService };
